import { validateEmail, validateValueLenthe } from "./validators";
import { validatePasswordStrength } from "./password";

export const validateAuthForm = (data, mode) => {
  // Vérification des champs requis
  for (const key in data) {
    if (!data[key] && key !== "rememberMe") {
      return { valid: false, msg: "Veuillez remplir tous les champs requis." };
    }
  }

  // Validation du nom et prénom pour l'inscription
  if (mode === "signup") {
    if (!validateValueLenthe(data.last_name, 3)) {
      return { valid: false, msg: "Le nom doit contenir au moins 3 caractères." };
    }
    if (!validateValueLenthe(data.first_name, 3)) {
      return { valid: false, msg: "Le prénom doit contenir au moins 3 caractères." };
    }
  }

  // Validation de l'email
  if (!data.email || !validateEmail(data.email)) {
    return { valid: false, msg: "Veuillez entrer une adresse email valide." };
  }

  // Validation des mots de passe pour l'inscription
  if (mode === "signup") {
    if (data.password !== data.confpassword) {
      return { valid: false, msg: "Les mots de passe ne sont pas identiques." };
    }
    const passwordCheck = validatePasswordStrength(data.password);
    if (!passwordCheck.valid) {
      return passwordCheck;
    }
  }

  return { valid: true };
};

export const validate2FACode = (code) => {
  if (code.length !== 6 || !/^[0-9]{6}$/.test(code)) {
    return { valid: false, msg: "Code invalide" };
  }
  return { valid: true };
};
